module.exports = __webpack_public_path__ + "img/mainOutbound.efd60ae9.png";